<template>
  <div class="tutorial-tester" ref="tutorialTesterContainer">
    <button id="btn-tutorial-tester-launcher" type="button" ref="btnToggler">
      <span>T</span><span class="button-hidden-text">utorials Tester</span>
    </button>

    <div class="config">
      <ul class="modes" ref="eventTypeChoices">
        <li><label for="tutorial-tester-option-CHOOSE_VORTEX">
          <input type="radio" id="tutorial-tester-option-CHOOSE_VORTEX" name="tutorial-tester-options[]"
                 value="CHOOSE_VORTEX" checked>CHOOSE_VORTEX</label>
        </li>
        <li><label for="tutorial-tester-option-CHOOSE_INITIAL_THEME">
          <input type="radio" id="tutorial-tester-option-CHOOSE_INITIAL_THEME" name="tutorial-tester-options[]"
                 value="CHOOSE_INITIAL_THEME">CHOOSE_INITIAL_THEME</label>
        </li>
        <li><label for="tutorial-tester-option-RECORD_TESTIMONIAL">
          <input type="radio" id="tutorial-tester-option-RECORD_TESTIMONIAL" name="tutorial-tester-options[]"
                 value="RECORD_TESTIMONIAL">RECORD_TESTIMONIAL</label>
        </li>
        <li><label for="tutorial-tester-option-BREADCRUMBS_THEMES">
          <input type="radio" id="tutorial-tester-option-BREADCRUMBS_THEMES" name="tutorial-tester-options[]"
                 value="BREADCRUMBS_THEMES">BREADCRUMBS_THEMES</label>
        </li>

        <li><label for="tutorial-tester-option-DISCOVER_MORE_THEMES">
          <input type="radio" id="tutorial-tester-option-DISCOVER_MORE_THEMES" name="tutorial-tester-options[]"
                 value="DISCOVER_MORE_THEMES">DISCOVER_MORE_THEMES</label>
        </li>

        <li><label for="tutorial-tester-option-HIGHLIGHT">
          <input type="radio" id="tutorial-tester-option-HIGHLIGHT" name="tutorial-tester-options[]"
                 value="HIGHLIGHT">HIGHLIGHT (no text)</label>
        </li>

        <li><label for="tutorial-tester-option-HIGHLIGHTSARRAY">
          <input type="radio" id="tutorial-tester-option-HIGHLIGHTSARRAY" name="tutorial-tester-options[]"
                 value="HIGHLIGHTSARRAY">HIGHLIGHTS ARRAY (no text)</label>
        </li>


        <li><strong>Special ones:</strong></li>
        <li><label for="tutorial-tester-option-CLOSE_TUTORIAL">
          <input type="radio" id="tutorial-tester-option-CLOSE_TUTORIAL" name="tutorial-tester-options[]"
                 value="CLOSE_TUTORIAL">CLOSE_TUTORIAL</label>
        </li>
        <li><label for="tutorial-tester-option-ADD-BG">
          <input type="radio" id="tutorial-tester-option-ADD-BG" name="tutorial-tester-options[]"
                 value="ADD-BG">Add a coloured backdrop</label>
        </li>

        <li><label for="tutorial-tester-option-SHOWOUTRO">
          <input type="radio" id="tutorial-tester-option-SHOWOUTRO" name="tutorial-tester-options[]"
                 value="SHOWOUTRO">Show me the outro</label>
        </li>

        <li><label for="tutorial-tester-option-OUTRO_2D_FINISHED">
          <input type="radio" id="tutorial-tester-option-OUTRO_2D_FINISHED" name="tutorial-tester-options[]"
                 value="OUTRO_2D_FINISHED">Show credits</label>
        </li>
      </ul>

      <button type="button" ref="buttonLauncher" class="btn-launcher">Show the tutorial!</button>
    </div>

  </div>
</template>

<script>
import BusEvent from '../../../../shared/js/BusEvent';


export default {
  name : "TutorialTester",

  mounted ()
  {


    this.$refs.btnToggler.addEventListener( 'click', () =>
    {
      if ( this.$refs.tutorialTesterContainer.classList.contains( 'open' ) )
      {
        this.$refs.tutorialTesterContainer.classList.remove( 'open' );

      } else
      {
        this.$refs.tutorialTesterContainer.classList.add( 'open' );

      }
    } );


    this.$refs.buttonLauncher.addEventListener( 'click', () =>
    {


      const layoutModes = {
        'CHOOSE_VORTEX'        : 'center',
        'CHOOSE_INITIAL_THEME' : 'center',
        'RECORD_TESTIMONIAL'   : 'top-left-of',
        'BREADCRUMBS_THEMES'   : 'top-right-of',
        'DISCOVER_MORE_THEMES' : 'above-centered',
      }
      const type        = this.$refs.eventTypeChoices.querySelector( 'input[type=radio]:checked' ).value;
      const layoutMode  = layoutModes[ type ] || 'center';

      if ( 'ADD-BG' === type )
      {
        if ( this.$refs.tutorialTesterContainer.classList.contains( 'colour-bg' ) )
        {
          this.$refs.tutorialTesterContainer.classList.remove( 'colour-bg' );

        } else
        {
          this.$refs.tutorialTesterContainer.classList.add( 'colour-bg' );

        }
      }


      let eventOptions = {
        type,
        layoutMode,
        textContent : type,
      };

      if ( 'HIGHLIGHT' === type )
      {
        eventOptions.highlightX = 600;
        eventOptions.highlightY = 400;
        delete eventOptions.textContent;
      }

      if ( 'HIGHLIGHTSARRAY' === type )
      {
        eventOptions.highlights = [
          { x : 50, y : 100 },
          { x : 500, y : 800 },
          { x : 500, y : 50 },
        ]

        // just tricking it, without adding a new type
        eventOptions.type = 'HIGHLIGHT';
      }

      if ( 'SHOWOUTRO' === type )
      {
        document.dispatchEvent( new BusEvent( BusEvent.EVENTS.OUTRO_START_TEXT ) );
        return;
      }


      document.dispatchEvent( new BusEvent( BusEvent.EVENTS.TUTORIAL_EVENT, eventOptions ) );

      //console.log( type + ' Tutorial Bus Event dispatched', eventOptions );
    } );

  },
}

</script>

<style scoped>
.tutorial-tester
{
  display:none;
}
</style>
